import * as notify from '../utils/notify';

const callApi = async (url, options, noJson) => {
	try {
		const response = await fetch(url, options);
		if (!response.ok) handleError(response);
		else {
			if (noJson) return response.text();
			const data = await response.json();
			return data;
		}
	} catch (e) {
		console.log('catchUrl', url);
		console.error('catchError', e);
		notify.error('No se ha podido obtener respuesta del servidor.');
	}
};

const handleError = (response) => {
	console.log('handleError: ', response);
	notify.error(`Error ${response.status}: ${response.statusText}`);
};

export const callApiLogin = async (url) => {
	try {
		const response = await fetch(url);
		if (!response.ok) handleError(response);
		else {
			if (response.redirected) {
				return response;
			} else {
				const data = await response.json();
				return data;
			}
		}
	} catch (e) {
		console.log('catch', url);
		console.error('catch', e);
	}
};

export const callApiPost = async (url, data, auth = false) => {
	return await callApi(url, {
		method: 'POST',
		body: JSON.stringify(data),
		headers: auth
			? {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${getToken()}`,
				ADUserName: getAuthUserName(),
			}
			: {
				'Content-Type': 'application/json',
			},
	});
};

export const callApiGet = async (url, auth = false) => {
	return await callApi(url, {
		method: 'GET',
		headers: auth
			? {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${getToken()}`,
				ADUserName: getAuthUserName(),
			}
			: {
				'Content-Type': 'application/json',
			},
	});
};

export const callApiPostUpload = async (url, data, auth = false) => {
	return await callApi(url, {
		method: 'POST',
		body: data,
		headers: auth
			? {

				Authorization: `Bearer ${getToken()}`,
				ADUserName: getAuthUserName(),
			}
			: {

			},
	});
};

